import React, { Component } from "react";
import { BoxInfo, ErrorNotification, MnemoLoading, MSection } from "components/misc";
import { Button, Container, Row, Col } from "design-react-kit";
import { MSelect } from "components/forms";
import { dateHelper, networkErrorHelper } from "libs";
import { enrollmentEvaluationService } from "libs/api/enrollmentEvaluationService";

export class BandoEvaluationLog extends Component {
  emptyFields = {
    company: "",
    competitionClass: "",
    region: "",
    bandoedition: "",
    aa: "",
  };

  state = {
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
    loading: false,
    payloadCurrentCC: [],
    payloadCurrentRegion: [],
    bandoEvaluationLogs: [],
    currentCompany: "",
    currentCC: "",
    currentRegion: "",
    currentEdition: "",
    currentAA: "",
  };

  PAYLOAD_YEAR = {
    options: [
      { label: "SELEZIONA UN ANNO ACCADEMICO", value: 0 },
      { label: "2024/2025", value: 2024 },
      { label: "2025/2026", value: 2025 },
      { label: "2026/2027", value: 2026 },
    ],
  };

  getSearchFields = () => {
    const { currentAA } = this.state;

    let editionOptions = [
      { label: "Seleziona edizione", value: "" },
      { label: "UNO: da 29/03 al 08/04 2025", value: "1" },
      { label: "DUE: da 15/04 2025", value: "2" },
      { label: "TRE: da 22/06 al 10/07 2025", value: "3" },
      { label: "QUATTRO: da 22/06 al 30/07 2025", value: "4" },
    ];

    //aa 2025/2026
    if (parseInt(currentAA) === 2025) {
      editionOptions = [
        { label: "Seleziona edizione", value: "" },
        { label: "UNO", value: "1" },
        { label: "DUE", value: "2" },
        { label: "TRE", value: "3" },
        { label: "QUATTRO", value: "4" },
        { label: "V", value: "5" },
      ];

      //aa 2026/2027
    } else if (parseInt(currentAA) === 2026) {
      editionOptions = [
        { label: "filtro edizione", value: "" },
        { label: "UNO", value: "1" },
      ];
    }

    return [
      {
        field: "bandoedition",
        name: "bandoedition",
        label: "Edizione Bando",
        payload: { options: editionOptions },
        component: MSelect,
        onChange: (_, value) => this.onChangeEdition(_, value),
      },
      {
        field: "company",
        name: "company",
        label: "Ente",

        payload: {
          options: [
            { label: "Seleziona ente", value: "" },
            { label: "Unicamillus", value: "unicamillus" },
            { label: "IUL", value: "iul" },
            { label: "UNITELMA", value: "unitelma" },
            { label: "REGGIO", value: "reggio" },
          ],
        },
        component: MSelect,
        onChange: (_, value) => this.onChangeCompany(_, value),
      },
    ];
  };

  onChangeAA = (_, value) => {
    this.setState({
      currentAA: value,
      currentEdition: "",
      currentCompany: "",
      currentCC: "",
      currentRegion: "",
      payloadCurrentCC: [],
      payloadCurrentRegion: [],
    });
  };

  onChangeEdition = (_, value) => {
    this.setState({
      currentEdition: value,
      currentCC: "",
      currentRegion: "",
      payloadCurrentCC: [],
      payloadCurrentRegion: [],
    });
  };

  onChangeCompany = (_, value) => {
    this.setState({
      currentCompany: value,
      currentCC: "",
      currentRegion: "",
      payloadCurrentCC: [],
      payloadCurrentRegion: [],
    });
  };

  onChangeCompetitionClass = (_, value) => {
    const { bandoEvaluationLogs } = this.state;

    //find regions for CC
    const regions = bandoEvaluationLogs.filter((log) => log.competitionClass === value).map((log) => log.region);

    const regionOptions = [
      { label: "Seleziona regione", value: "" },
      ...[...new Set(regions)].map((region) => ({
        label: region.toUpperCase(),
        value: region,
      })),
    ];

    this.setState({
      currentCC: value,
      currentRegion: "",
      payloadCurrentRegion: { options: regionOptions },
    });
  };

  onChangeRegion = (_, value) => {
    this.setState({ currentRegion: value });
  };

  onSearchForm = () => {
    this.loadRemote();
  };

  loadRemote = () => {
    const { currentCompany, currentEdition, currentAA } = this.state;
    if (!currentCompany || !currentEdition) {
      ErrorNotification.render("Devi selezionare una edizione e una università");
      return;
    }

    this.setState({ loading: true });

    enrollmentEvaluationService
      .bandoEvaluationLogList(currentEdition, currentAA, currentCompany)
      .then(({ data }) => {
        const bandoEvaluationLogs = data.payload.bandoEvaluationLogs;

        const uniqueCC = [...new Set(bandoEvaluationLogs.map((log) => log.competitionClass))];

        const ccOptions = [{ label: "Seleziona classe di concorso", value: "" }, ...uniqueCC.map((cc) => ({ label: cc, value: cc }))];

        this.setState({
          bandoEvaluationLogs,
          payloadCurrentCC: { options: ccOptions },
          loading: false,
          currentCC: "",
          currentRegion: "",
          payloadCurrentRegion: {
            options: [{ label: "Seleziona regione", value: "" }],
          },
        });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else
          this.setState({
            loading: false,
          });
      });
  };

  getFilteredLogs = () => {
    const { bandoEvaluationLogs, currentCC, currentRegion } = this.state;
    let filtered = bandoEvaluationLogs;

    if (currentCC) {
      filtered = filtered.filter((log) => log.competitionClass === currentCC);
    }

    if (currentRegion) {
      filtered = filtered.filter((log) => log.region === currentRegion);
    }

    return filtered;
  };

  //--- ---
  render() {
    const { loading, payloadCurrentCC, payloadCurrentRegion, bandoEvaluationLogs, currentCC, currentRegion, currentAA } = this.state;

    const logs = this.getFilteredLogs();
    const searchFields = this.getSearchFields();

    return (
      <>
        {loading && <MnemoLoading></MnemoLoading>}
        <Container className="m-4">
          <h1>Consultazione Scorrimenti</h1>
          <MSection>
            <Row className="mt-4">
              <Col md={12}>
                <MSelect onChange={this.onChangeAA} id="aa" payload={this.PAYLOAD_YEAR} />
              </Col>
            </Row>
            {currentAA > 0 && (
              <>
                <Row className="mt-3">
                  <Col md={4}>
                    <MSelect key={`edition-${currentAA}`} {...searchFields[0]} />
                  </Col>
                  <Col md={4}>
                    <MSelect {...searchFields[1]} />
                  </Col>
                  <Col md={4}>
                    <Button className="mx-2" color="primary bg-dark" onClick={this.onSearchForm}>
                      Carica operazioni
                    </Button>
                  </Col>
                </Row>

                {bandoEvaluationLogs && bandoEvaluationLogs.length > 0 && (
                  <Row className="mt-3">
                    <Col md={6}>
                      <MSelect value={currentCC} label="Classe di concorso" payload={payloadCurrentCC} onChange={this.onChangeCompetitionClass} />
                    </Col>
                    <Col md={6}>
                      <MSelect
                        key={`region-select-${currentCC}`}
                        label="Regione"
                        value={currentRegion}
                        onChange={this.onChangeRegion}
                        payload={payloadCurrentRegion}
                        disabled={!currentCC}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}

            <hr />
          </MSection>

          <MSection>
            {!logs || logs.length === 0 ? (
              <BoxInfo>Non ci sono dati da mostrare in database.</BoxInfo>
            ) : (
              <Row>
                <table className="MTable table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Nome completo</th>
                      <th>Codice Registrazione</th>
                      <th>Codice Corso</th>
                      <th>Classe di Concorso</th>
                      <th>Regione</th>
                      <th>Operazione</th>
                      <th>Data/Ora Operazione</th>
                      <th>Tipologia operazione</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.name} {item.surname}
                        </td>
                        <td>{item.registrationCode}</td>
                        <td>{item.courseCode}</td>
                        <td>{item.competitionClass}</td>
                        <td>{item.region}</td>
                        <td>{item.action}</td>
                        <td>{dateHelper.toITDateTime(item.actionTime)}</td>
                        <td>{item.operatorId > 0 ? "Manuale" : "Automatica"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Row>
            )}
          </MSection>
        </Container>
      </>
    );
  }
}
